export function initNav() {
  const $navToggler = $('[data-nav-toggler]');
  $navToggler.on('click', (e) => {
    e.preventDefault();
    toggleNav();
  });
}

function toggleNav() {
  window.WK.utilsBus.toggleNavPopup();
}
